/**
 * Tres Commas rows into the Voluum + Binom campaign list (useAllCampaigns).
 * For Media Devoted | Created By Ciro Autiero
 *
 * Tres Commas campaign ids are imported from Voluum, so the same id can sit on
 * both trackers: every row is tagged 'tres-commas' and stays its own row.
 */

import type { TresCommasCampaign } from '@/hooks/tres-commas/useTresCommasCampaigns';
import type { Campaign } from '@/hooks/voluum/useVoluum';

const byName = (a: Campaign, b: Campaign) => (a.name ?? '').localeCompare(b.name ?? '');

/** Voluum + Binom rows untouched; Tres Commas rows tagged and merged in by name. */
export function mergeTresCommasCampaigns(
  base: Campaign[],
  tresCommas: TresCommasCampaign[] | undefined,
): Campaign[] {
  if (!tresCommas || tresCommas.length === 0) return base;
  const tagged = tresCommas.map((c): Campaign => ({ ...c, provider: 'tres-commas' }));
  return [...base, ...tagged].sort(byName);
}
